import React from 'react';
import { connect } from 'react-redux';
import { setActiveBlock, setHologramPosition, addToSwap } from 'components/collage/CollageSlice.js';

// CSS
import './OverlaySpinner.css';

// Images
import GandrLogo from 'img/layout-icons/gandr-logo-v2.png';

class OverlaySpinner extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
    }
  }

  render() {
    return (
      <div className={'OverlaySpinner'}>
        <img src={GandrLogo} className="SpinnerIcon" />
        <span>{this.props.loadText}</span>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  collage: state.collage
});

export default connect(
  mapStateToProps,
  {setActiveBlock, setHologramPosition, addToSwap}
)(OverlaySpinner)
